import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const FirstPageDebitCreditNoteEntry = (props) => {
    return (
        <>
            {/* 1. Item Search  */}
            <div className="item-search">
                <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                    <div className="search-grp w-[60%]">
                        <label>Party Name</label>
                        <input
                            type="text"
                            id="partyName"
                            name="partyName"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.filterDetails.partyName}
                            onChange={(event) =>
                                props.handleChange(event, "partyName", "filterDetails")
                            }
                        />
                    </div>

                    <div className="search-grp w-[40%]">
                        <label>Arranged By</label>
                        <select
                            name="arrangedBy"
                            className="w-full"
                            value={props.filterDetails.arrangedBy && props.filterDetails.arrangedBy !== 'Select' && props.arrangedByList.find(
                                (party) => party.value === props.filterDetails.arrangedBy
                            ).value}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "arrangedBy",
                                    "filterDetails"
                                )
                            }
                        >
                            <option value="Select">Select</option>
                            {props.arrangedByList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.arrangedBy}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <button className="add-btn" onClick={props.getGeneralDebitNoteEntrySRNo}>
                    Add New
                </button>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                    <table className="itemList">
                        <thead>
                            <tr>
                                <td className='w-[15%]'>Sr. No.</td>
                                <td className='w-[15%]'>Date</td>
                                <td className='w-[35%]'>Party Name</td>
                                <td className='w-[20%]'>Net Amount</td>
                                <td className="w-[15%]" style={{ textAlign: "center" }}>Action</td>
                            </tr>
                        </thead>

                        <tbody>
                            {props.generalDebitNoteList && props.generalDebitNoteList.length > 0 ? (
                                props.generalDebitNoteList.map((item, key) => (
                                    <tr key={key}>
                                        <td>{item.noteNo}</td>
                                        <td>{moment(item.date).format('DD MMM yyyy')}</td>
                                        <td>{item.partyName}</td>
                                        <td>{Number(item.grandTotal).toFixed(2)}</td>
                                        <td className='!text-center'>
                                            <button
                                                className="search-btn"
                                                onClick={() => props.getCreditDebitNoteEntryById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteCreditDebitNoteEntryById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : props.generalDebitNoteList
                                && props.generalDebitNoteList.length === 0
                                && props.tableStatus !== "" ? (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                        {props.tableStatus}
                                    </td>
                                </tr>
                            ) : props.generalDebitNoteList
                                && props.generalDebitNoteList.length === 0
                                && props.tableStatus === "" ? null : ""}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default FirstPageDebitCreditNoteEntry;